<!--
  Modifiers are captured on the <label>, not the <input>: the pointer may land on
  the styled box instead of the (absolutely positioned) input, and label
  activation still fires `change` on the input. Listening on the label catches
  both paths, plus keyboard activation via bubbling.
-->
<label
  class="ui-checkbox"
  [class.ui-checkbox--disabled]="disabled"
  (mousedown)="captureModifiers($event)"
  (keydown)="captureModifiers($event)"
  (click)="stopPropagation($event)"
>
  <input
    type="checkbox"
    class="ui-checkbox__input"
    [checked]="checked"
    [indeterminate]="indeterminate"
    [disabled]="disabled"
    [attr.aria-label]="ariaLabel || null"
    (change)="onChange($event)"
  />
  <span class="ui-checkbox__box" aria-hidden="true"></span>
</label>
